import React, { useEffect, useState } from 'react';
import VideoPlayer from './VideoPlayer';
import { useLocation } from 'react-router-dom';

const BEARER_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJzZXNzaW9uSWQiOiJlZjk3ZWNjMS03OGU1LTQ4MGItYWNhYS1kMmRkZjY0NDQ4YWYiLCJzdWIiOjEsImVtYWlsIjoiYWRtaW4gYWRtaW4gYWRtaW4iLCJvcmdhbmlzYXRpb25JZCI6MSwiaWF0IjoxNzUwMTY0NjIzLCJleHAiOjIwNjU1MjQ2MjN9.m7AW1hfO7jfdK1jNGhEgKC4CsRY1kgfXG2c1_dUSeQg';

const App: React.FC = () => {
  const location = useLocation();
  const [projectData, setProjectData] = useState<any>(null);
  const [visitData, setVisitData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // Парсим path: /3/doidrandom
  const pathParts = location.pathname.split('/').filter(Boolean);
  var visitId = 0;
  const presId = pathParts[0];
  const doctorId = pathParts[1];
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  window.addEventListener("orientationchange", function() {

    setTimeout(function() {
        const isLandscape = window.innerWidth > window.innerHeight;
        console.log(isLandscape)
        if (isLandscape && isSafari) {
            window.scrollTo(0, 100);
            // @ts-ignore
            document.getElementById('videoplayer').style.height = window.screen.width - 25 + 'px'
        } else {
            window.scrollTo(0, 0);
            document.body.classList.remove('disable-scroll');
            // @ts-ignore
            document.getElementById('videoplayer').style.height = '100vh'
        }

    }, 300);
  });

    useEffect(() => {
        // Запретить скролл пользователю
        document.body.classList.add('disable-scroll');
        const disableTouchScroll = (e: { preventDefault: () => void; stopPropagation: () => void; }) => { e.preventDefault(); e.stopPropagation(); };
        document.body.addEventListener('touchmove', disableTouchScroll, { passive: false });

        // Очистка
        return () => {
            document.body.classList.remove('disable-scroll');
            document.body.removeEventListener('touchmove', disableTouchScroll);
        };
    }, []);

    // Программная прокрутка по кнопке
    // const scrollDown = () => window.scrollTo({ top: 500, behavior: 'smooth' });

  useEffect(() => {
    if (!presId) return;
    fetch(`https://stage.selfdetailing.ru/api/project/${presId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
          'Authorization':  `Bearer ${BEARER_TOKEN}`
      },
    })
        .then(res => res.json())
        .then(data => {
            setProjectData(data);
            visitId = data.visitId

            fetch(`https://stage.selfdetailing.ru/api/visit/${visitId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization':  `Bearer ${BEARER_TOKEN}`
                },
            })
                .then(res => res.json())
                .then(data => {
                    setVisitData(data);
                    setLoading(false);
                })
                .catch(() => setLoading(false));
        })
        .catch(() => setLoading(false));
  }, [presId]);


  if (loading) return <div>Загрузка...</div>;
  if (!projectData) return <div>Ошибка загрузки проекта</div>;

  return (
      <>
        <div id='hideafterscroll' style={{height: 'calc(100vh + 200px)'}}></div>
        <VideoPlayer
            videoUrl={'https://stage.selfdetailing.ru'+projectData.video.raw}
            slides={visitData.slides}
            visit={visitData}
            project={projectData}
            doctorId={doctorId}
        />
      </>

  );
};

export default App;
